import { TableFilter } from "@neonumy/ant-design";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useReceiptsApi from "./hooks/useReceiptsApi";
import useReceiptsFilters from "./hooks/useReceiptsFilters";
import { getColumns } from "./columns";
import PdfDrawer from "./components/PdfDrawer";

export default function Receipts(): React.ReactElement {
  const { t } = useTranslation();
  const windowHeight = useGetWindowHeight();
  const urlParams: RouteParams = useParams();

  const [showPdfDrawer, setShowPdfDrawer] = useState(false);

  const {
    refetch,
    loading,
    dataSource,
    listReceipts,
    totalCount,
    getReceiptUrl,
    receiptPdfUrl,
    setReceiptPdfUrl,
    loadingPdf,
  } = useReceiptsApi();

  const {
    filters,
    setFilters,
    currentPage,
    pageSize,
    handleSearchFilters,
    handleResetFilter,
    handlePagination,
    fetchInitialData,
  } = useReceiptsFilters({
    companyId: urlParams.companyId,
    listReceipts,
    refetch,
  });

  const handleViewPdf = (id: ID) => {
    getReceiptUrl({ variables: { id } });
    setShowPdfDrawer(true);
  };

  const handleClosePdfDrawer = () => {
    setShowPdfDrawer(false);
    setReceiptPdfUrl("");
  };

  const columns = getColumns({
    t,
    companyId: urlParams.companyId,
    handleViewPdf,
    loadingPdf,
  });

  useEffect(() => {
    if (urlParams.companyId) {
      fetchInitialData();
    }
  }, [urlParams.companyId]);

  return (
    <>
      <Typography.Title className="documents-title" level={4}>
        {t("Receipts")}
      </Typography.Title>
      <TableFilter
        className="antd-newrai-table"
        scroll={{ y: windowHeight - 350 }}
        dataSource={dataSource}
        loading={loading}
        columns={columns}
        defaultSearchFilter={handleSearchFilters}
        defaultResetFilter={handleResetFilter}
        defaultFiltersObject={filters}
        defaultFilterSet={setFilters}
        pagination={{
          onChange: handlePagination,
          showSizeChanger: true,
          current: currentPage,
          pageSize: pageSize,
          total: totalCount,
          showTotal: (total: number) => t("Total table items", { count: total }),
        }}
        debounced={true}
      />
      <PdfDrawer
        open={showPdfDrawer}
        onClose={handleClosePdfDrawer}
        pdfUrl={receiptPdfUrl}
        loading={loadingPdf}
      />
    </>
  );
}
